import { render, staticRenderFns } from "./BunqResultModal.vue?vue&type=template&id=5758ab74&scoped=true&"
import script from "./BunqResultModal.vue?vue&type=script&lang=js&"
export * from "./BunqResultModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5758ab74",
  null
  
)

export default component.exports